import { BikeRoute } from "@/modules/bikes/routes/bike.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/bikes/$bikeId")({
	component: BikeRoute,
});
